/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState } from "react";
import classes from "../checkout.module.css";
import Grid from "@mui/material/Grid";
import stateCode from "../../../../helper/stateCode";
import actionTypes from "../../../../store/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getStateName, getStatesList } from "../../../../helper/getStateList";
import TableContainer from "@mui/material/TableContainer";

const CustomerDetailBlock = (props) => {
  const detail = props.customerDetails;
  const [maxHeight, setMaxHeight] = useState(0);
  useEffect(() => {
    const table1 = document
      .getElementById("accountTable")
      .getBoundingClientRect().height;
    const table2 = document
      .getElementById("billingTable")
      .getBoundingClientRect().height;
    const table3 = document
      .getElementById("shippingTable")
      .getBoundingClientRect().height;
    const allTableHeight = [
      Math.ceil(table1),
      Math.ceil(table2),
      Math.ceil(table3),
    ];
    setMaxHeight(Math.max(...allTableHeight));
    if (
      props.customerDetails &&
      props.customerDetails.billing &&
      props.customerDetails.billing.state
    ) {
      if (
        props.customerDetails &&
        props.customerDetails.billing &&
        props.customerDetails.billing.country
      ) {
        setStateName(
          props.customerDetails.billing.country,
          props.customerDetails.billing.state,
          "billing",
        );
      } else {
        setBillingStateName(props.customerDetails.billing.state);
        setIsBillingStateLoading(false);
      }
    }
    if (
      props.customerDetails &&
      props.customerDetails.shipping &&
      props.customerDetails.shipping.state
    ) {
      if (
        props.customerDetails &&
        props.customerDetails.shipping &&
        props.customerDetails.shipping.country
      ) {
        setStateName(
          props.customerDetails.shipping.country,
          props.customerDetails.shipping.state,
          "shipping",
        );
      } else {
        setShippingStateName(props.customerDetails.shipping.state);
        setIsShippingStateLoading(false);
      }
    }
  }, []);
  const setCountryName = (country) => {
    var list = props.countriesList;
    var index = list.findIndex((a) => a.id === country);
    if (index > -1) {
      return list[index].name;
    } else {
      return country;
    }
  };
  const [billingStateName, setBillingStateName] = useState("--");
  const [shippingStateName, setShippingStateName] = useState("--");
  const [isBillingStateLoading, setIsBillingStateLoading] = useState(true);
  const [isShippingStateLoading, setIsShippingStateLoading] = useState(true);
  const setStateName = (country, state, type) => {
    getStateName(country, state)
      .then((res) => {
        if (type === "billing") {
          setBillingStateName(res);
          setIsBillingStateLoading(false);
        }
        if (type === "shipping") {
          setShippingStateName(res);
          setIsShippingStateLoading(false);
        }
      })
      .catch((err) => {
        if (type === "billing") {
          setBillingStateName(state);
          setIsBillingStateLoading(false);
        }
        if (type === "shipping") {
          setShippingStateName(state);
          setIsShippingStateLoading(false);
        }
        // if (err.response && err.response.data && err.response.data.message) {
        //     props.setErrorMessage(err.response.data.message, false)
        // } else {
        //     props.setErrorMessage(props.t('FAILED_TO_LOAD_STATES'), false)
        // }
      });
  };
  return (
    <div>
      <Grid container spacing={1}>
        <Grid
          item
          className={classes.customerInfoTable}
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <div style={{ position: "relative" }}>
            <h3 style={{ marginTop: 0 }}>
              <span>{props.t("ACCOUNT")}</span>
              {/* {props.editOption ? <button onClick={() => { props.edit() }} className={classes.button} style={{ marginTop: "10px" }}>edit</button> : null} */}
              {/* {props.editOption ? <button onClick={() => { props.edit() }} className={classes.button}>Change Customer</button> : null} */}
              {props.editOption ? (
                // <Tooltip title="Change Customer">
                //     <IconButton onClick={() => { props.edit() }} style={{ position: 'absolute', left: '80px', top: '-7px' }}>
                //         <EditIcon />
                //     </IconButton>
                // </Tooltip>
                <button
                  onClick={() => {
                    props.edit(0);
                  }}
                  className={classes.button}
                >
                  {props.t("EDIT")}
                </button>
              ) : null}
            </h3>
          </div>
          {/* <TableContainer> */}
          <table
            className={`${classes.customerDetailTabel}`}
            id="accountTable"
            style={{ height: maxHeight, background: "white" }}
          >
            <tbody>
              <tr>
                <td>{props.t("ACCOUNT_NAME")}</td>
                <td align="center">:</td>
                <td>{detail.accountName}</td>
              </tr>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <tr>
                  <td>{props.t("BAN")}</td>
                  <td align="center">:</td>
                  <td>{detail.ban}</td>
                </tr>
              )}
              <tr>
                <td>{props.t("CONTACT")}</td>
                <td align="center">:</td>
                <td>
                  {detail.firstName} {detail.lastName}
                </td>
              </tr>
              <tr>
                <td>{props.t("OFFICE_PHONE")}</td>
                <td align="center">:</td>
                <td>{detail.officePhone ? detail.officePhone : "--"}</td>
              </tr>
              <tr>
                <td>{props.t("MOBILE_PHONE")}</td>
                <td align="center">:</td>
                <td>{detail.mobilePhone ? detail.mobilePhone : "--"}</td>
              </tr>
              <tr>
                <td>{props.t("EMAIL")}</td>
                <td align="center">:</td>
                <td style={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                  {detail.email ? detail.email : "--"}
                </td>
              </tr>
            </tbody>
          </table>
          {/* </TableContainer> */}
        </Grid>
        <Grid
          item
          className={classes.customerInfoTable}
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <div>
            <h3 style={{ marginTop: 0 }}>
              <span>{props.t("BILLING")}</span>
            </h3>
            {/* {props.editOption ? <button onClick={() => { props.edit() }} className={classes.button} style={{ marginTop: "10px" }}>edit</button> : null} */}
          </div>
          {
            detail.billing.attention ? (
              // <TableContainer>
              <table
                className={classes.customerDetailTabel}
                id="billingTable"
                style={{ height: maxHeight, background: "white" }}
              >
                <tbody>
                  <tr>
                    <td>{props.t("ATTENTION")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {detail.billing.attention
                        ? detail.billing.attention
                        : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>{props.t("PHONE")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {detail.billing.phone ? detail.billing.phone : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>{props.t("STREET1")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {detail.billing.street1 ? detail.billing.street1 : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {props.t("CITY")}, {props.t("STATE")}, {props.t("ZIP")}
                    </td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {isBillingStateLoading ? (
                        "Loading..."
                      ) : (
                        <>
                          {detail.billing.city ? detail.billing.city : "--"}
                          ,&nbsp;
                          {/* {detail.billing.country ? stateCode.state[detail.billing.country][stateCode.state[detail.billing.country].findIndex(a => a.abbreviation === detail.billing.state)].name : '--'},&nbsp; */}
                          {detail.billing.stateName
                            ? detail.billing.stateName
                            : billingStateName}
                          &nbsp;
                          {detail.billing.zip ? detail.billing.zip : "--"}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{props.t("COUNTRY")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {/* {detail.billing.country ? stateCode.country[stateCode.country.findIndex(a => a.abbreviation === detail.billing.country)].name : '--'} */}
                      {detail.billing.country
                        ? setCountryName(detail.billing.country)
                        : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td align="center">&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            ) : (
              // </TableContainer>
              // <TableContainer>
              <table
                className={classes.customerDetailTabel}
                id="billingTable"
                style={{ height: maxHeight, background: "white" }}
              >
                <tbody>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td
                      rowSpan={2}
                      style={{ textAlign: "center" }}
                      className="text-title"
                    >
                      {props.t("NOT_SET")}
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            )
            // </TableContainer>
          }
        </Grid>
        <Grid
          item
          className={classes.customerInfoTable}
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <div>
            <h3 style={{ marginTop: 0 }}>
              <span>{props.t("SHIPPING")}</span>
            </h3>
            {/* {props.editOption ? <button onClick={() => { props.edit() }} className={classes.button} style={{ marginTop: "10px" }}>edit</button> : null} */}
          </div>
          {
            detail.shipping.attention ? (
              // <TableContainer>
              <table
                className={classes.customerDetailTabel}
                id="shippingTable"
                style={{ height: maxHeight, background: "white" }}
              >
                <tbody>
                  {detail.shipping.accountName != "" && (
                    <tr>
                      <td>{props.t("ACCOUNT_NAME")}</td>
                      <td align="center">:</td>
                      <td style={{ width: "60%" }}>
                        {detail.shipping.accountName
                          ? detail.shipping.accountName
                          : "--"}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>{props.t("ATTENTION")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {detail.shipping.attention
                        ? detail.shipping.attention
                        : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>{props.t("PHONE")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {detail.shipping.phone ? detail.shipping.phone : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>{props.t("STREET1")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {detail.shipping.street1 ? detail.shipping.street1 : "--"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {props.t("CITY")}, {props.t("STATE")}, {props.t("ZIP")}
                    </td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {isShippingStateLoading ? (
                        "Loading..."
                      ) : (
                        <>
                          {detail.shipping.city ? detail.shipping.city : "--"}
                          ,&nbsp;
                          {/* {detail.shipping.country ? stateCode.state[detail.shipping.country][stateCode.state[detail.shipping.country].findIndex(a => a.abbreviation === detail.shipping.state)].name : '--'},&nbsp; */}
                          {detail.shipping.stateName
                            ? detail.shipping.stateName
                            : shippingStateName}
                          &nbsp;
                          {detail.shipping.zip ? detail.shipping.zip : "--"}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{props.t("COUNTRY")}</td>
                    <td align="center">:</td>
                    <td style={{ width: "60%" }}>
                      {/* {detail.shipping.country ? stateCode.country[stateCode.country.findIndex(a => a.abbreviation === detail.shipping.country)].name : '--'} */}
                      {detail.shipping.country
                        ? setCountryName(detail.shipping.country)
                        : "--"}
                    </td>
                  </tr>
                  {detail.shipping.accountName == "" && (
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              // </TableContainer>
              // <TableContainer>
              <table
                className={classes.customerDetailTabel}
                id="shippingTable"
                style={{ height: maxHeight, background: "white" }}
              >
                <tbody>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td
                      rowSpan={2}
                      style={{ textAlign: "center" }}
                      className="text-title"
                    >
                      {props.t("NOT_SET")}
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            )
            // </TableContainer>
          }
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    loggedInUserType: state.auth.userLoginType,
    countriesList: state.global.countriesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(CustomerDetailBlock));
